const mutations = {
  SET_STATES(state, states) {
    state.states = states
  },
  SET_PROFESSIONS(state, professions) {
    state.professions = professions
  },
  SET_REGIONS(state, regions) {
    state.regions = regions
  },
  SET_REGIONARY_EMAILS(state, regionaryEmails) {
    state.regionaryEmails = regionaryEmails
  },
  SET_EMPLOYMENT_TYPES(state, employmentTypes) {
    state.employmentTypes = employmentTypes
  },
  SET_DISTANCE_ORDER_STATES(state, orderStates) {
    state.distanceOrderStates = orderStates
  },
  SET_EXTENSION_ORDER_STATES(state, orderStates) {
    state.extensionOrderStates = orderStates
  },
  SET_SYSTEM_SETTINGS(state, settings) {
    state.systemSettings = settings
  },
  SET_LOADED(state, isLoaded) {
    state.isLoaded = isLoaded
  },
}
export default mutations
